import React from "react";
import PropTypes from "prop-types";
import { Modal as BootstrapModal } from "reactstrap";
import SVG from "../SVG";

export default function ModalView(props) {
  const { children, className, handleClose, size, ...modalProps } = props;

  const classesString = size ? `modal-view modal-view-${size}` : "modal-view";

  return (
    <BootstrapModal className={`${classesString} ${className}`} {...modalProps}>
      {handleClose !== null && (
        <SVG.Close className="close-modal" onClick={handleClose} />
      )}
      {children}
    </BootstrapModal>
  );
}

ModalView.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.string
};

ModalView.defaultProps = {
  className: "",
  handleClose: null,
  size: null
};
